import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common'; // Import Location
import { ProfileService } from '../../core/services/profile.service';
import { State } from '../../core/models/state.model';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'; // Import ReactiveForms
import { NgxMaskModule } from 'ngx-mask';
import { CxIconComponent } from '../../shared/icon/cx-icon.component';

declare var $: any; // Declare $ for jQuery/Bootstrap modal

@Component({
  selector: 'app-landing-request-demo-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxMaskModule, CxIconComponent], // Add ReactiveFormsModule
  templateUrl: './landing-request-demo-page.component.html',
  styleUrl: './landing-request-demo-page.component.scss',
})
export class LandingRequestDemoPageComponent implements OnInit {
  statesList: State[] = [];
  demoForm: FormGroup;
  submitted = false;

  constructor(
    private profileService: ProfileService,
    private location: Location,
    private fb: FormBuilder
  ) {
    this.demoForm = this.fb.group({
      fullName: ['', Validators.required],
      workEmail: ['', [Validators.required, Validators.email]],
      phone: [''], // User said all fields required
      role: ['', Validators.required],
      organization: ['', Validators.required],
      country: ['United States'],
      state: [''],
      city: [''],
    });
  }

  ngOnInit(): void {
    this.fetchStateList();
  }

  fetchStateList() {
    this.profileService.fetchStateList().subscribe((res: any) => {
      if (res.success === 0) {
        this.statesList = res.data;
      }
    });
  }

  goBack() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    if (this.demoForm.invalid) {
      return;
    }

    const formData = this.demoForm.value;
    const demoRequestDTO = {
      fullName: formData.fullName,
      workEmail: formData.workEmail,
      phone: formData.phone,
      role: formData.role,
      organizationName: formData.organization, // Mapping organization to organizationName
      country: formData.country,
      state: formData.state,
      city: formData.city,
    };

    this.profileService.demoRequest(demoRequestDTO).subscribe(
      (res: any) => {
        if (res.success === 0) {
          $('#demoRequestModal').modal('show');
          this.demoForm.reset();
          this.submitted = false;
          // Set default country back to United States after reset
          this.demoForm.get('country')?.setValue('United States');
        } else {
          // Handle error if needed
          console.error('Error submitting demo request:', res.message);
        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }

  onModalClose() {
    $('#demoRequestModal').modal('hide');
    this.goBack();
  }
}
